import type { Option } from "ts-results-es";

export type Message = {
  id: Option<string>;

  // Just needs to be a soft link so we can grab a 'User' type if needed
  userId: number | null;

  // TODO: More types (e.g. text, image, video etc etc)
  message: string;

  side: MessageSide;

  title: string | null;
};

export enum MessageSide {
  left,
  right,
}
